const REFERER_HEADER = "referer";
const USER_AGENT_HEADER = "user-agent";
const CLOUDFRONT_VIEWER_COUNTRY_HEADER = "cloudfront-viewer-country";
const CLOUDFRONT_MOBILE_HEADER = "cloudfront-is-mobile-viewer";
const CLOUDFRONT_TABLET_HEADER = "cloudfront-is-tablet-viewer";
const CLOUDFRONT_DESKTOP_HEADER = "cloudfront-is-desktop-viewer";
const AB_TEST_EXACT_EVENT_NAME = "Ab-Test-Exact-Event-Name";
// Set by the ab-test-drawer Lambda@Edge when it reverse-proxies a localized page:
// the visitor's URL bar shows the public display-url (/lang/{locale}/{path}) while
// the content served comes from this original-url. Its PRESENCE means the drawer
// already resolved where this request must land, so the Generator must not redirect
// it anywhere. The value is not read here — the Generator already has req.path.
//
// Cross-repo contract — coordinate any change with ab-test-drawer:
//   - name is exactly "original-url" (no "x-" prefix; RFC 6648 deprecates it)
//   - must be in the CloudFront headers whitelist, or it is stripped in transit
//   - the Lambda must strip any client-supplied inbound value, or a visitor could
//     forge it and opt themselves out of all Generator redirects
const ORIGINAL_URL_HEADER = "original-url";
// Cloudflare headers
const CF_IPCOUNTRY_HEADER = "cf-ipcountry";
const CF_DEVICE_TYPE_HEADER = "cf-device-type";
module.exports = {
    REFERER_HEADER,
    USER_AGENT_HEADER,
    CLOUDFRONT_VIEWER_COUNTRY_HEADER,
    CLOUDFRONT_MOBILE_HEADER,
    CLOUDFRONT_TABLET_HEADER,
    CLOUDFRONT_DESKTOP_HEADER,
    AB_TEST_EXACT_EVENT_NAME,
    ORIGINAL_URL_HEADER,
    CF_IPCOUNTRY_HEADER,
    CF_DEVICE_TYPE_HEADER
};
